// extracted by mini-css-extract-plugin
export default {"wrapper":"userMenuModal_wrapper__bnEQM","textItem":"userMenuModal_textItem__9dbfX","customedSegment":"userMenuModal_customedSegment__Jt2ly"};